export * from "./blog-list.template";
export * from "./blog-article.template";
